<template>
  <patientComponent :isMy="false"></patientComponent>
</template>
<script>

import patientComponent from '@/components/patient/patient.vue'
export default {
  name: `patientmy`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    patientComponent
  }
}
</script>

<style lang="scss" scoped>
</style>